<app-select-filter
        [filterElementProcessor]="filter"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup"
        (_onSingleSelectionChange)="onChange($event)"
        [elements]="elements"
        [loading]="loading"
        [errorsMessages]="errorsMessages">
    <ng-template let-element='element' template-content>
        {{element.label}}
        <!-- Not good- Move label to form definition form -->
        <ng-container *ngIf="contextValue === 'FORM_CONTEXT_REPORT_COMPONENT'">({{element.shortLabel}})</ng-container>
    </ng-template>
</app-select-filter>
